/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CreateKnowledgeDocument200,
  CreateKnowledgeDocumentBody,
  CreateUploadBody,
  Document,
  ForbiddenResponse,
  GenerateUploadUrl200,
  GenerateUploadUrlBody,
  GetDocumentDownloadUrl200,
  GetDocumentDownloadUrlParams,
  GetKnowledgeDocuments200Item,
  InternalServerErrorResponse,
  ListDocuments200,
  NotFoundResponse,
  UnauthorizedResponse,
  UpdateDocumentBody,
  UpdateKnowledgeDocumentBody,
  Upload,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Generate upload URL
 */
export const generateUploadUrl = (
  organizationId: string,
  projectId: string,
  uploadId: string,
  generateUploadUrlBody: GenerateUploadUrlBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GenerateUploadUrl200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/uploads/${uploadId}/presigned-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateUploadUrlBody,
      signal,
    },
    options
  );
};

export const getGenerateUploadUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      uploadId: string;
      data: GenerateUploadUrlBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUploadUrl>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    uploadId: string;
    data: GenerateUploadUrlBody;
  },
  TContext
> => {
  const mutationKey = ["generateUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    {
      organizationId: string;
      projectId: string;
      uploadId: string;
      data: GenerateUploadUrlBody;
    }
  > = (props) => {
    const { organizationId, projectId, uploadId, data } = props ?? {};

    return generateUploadUrl(
      organizationId,
      projectId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateUploadUrl>>
>;
export type GenerateUploadUrlMutationBody = GenerateUploadUrlBody;
export type GenerateUploadUrlMutationError = unknown;

/**
 * @summary Generate upload URL
 */
export const useGenerateUploadUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateUploadUrl>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        uploadId: string;
        data: GenerateUploadUrlBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateUploadUrl>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    uploadId: string;
    data: GenerateUploadUrlBody;
  },
  TContext
> => {
  return useMutation(getGenerateUploadUrlMutationOptions(options), queryClient);
};
/**
 * Creates a new knowledge document record in the database with UPLOADING status and returns a presigned URL for file upload
 * @summary Create knowledge document and generate upload URL
 */
export const createKnowledgeDocument = (
  organizationId: string,
  createKnowledgeDocumentBody: CreateKnowledgeDocumentBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateKnowledgeDocument200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/knowledge/documents`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createKnowledgeDocumentBody,
      signal,
    },
    options
  );
};

export const getCreateKnowledgeDocumentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKnowledgeDocument>>,
    TError,
    { organizationId: string; data: CreateKnowledgeDocumentBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKnowledgeDocument>>,
  TError,
  { organizationId: string; data: CreateKnowledgeDocumentBody },
  TContext
> => {
  const mutationKey = ["createKnowledgeDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKnowledgeDocument>>,
    { organizationId: string; data: CreateKnowledgeDocumentBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createKnowledgeDocument(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKnowledgeDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createKnowledgeDocument>>
>;
export type CreateKnowledgeDocumentMutationBody = CreateKnowledgeDocumentBody;
export type CreateKnowledgeDocumentMutationError = unknown;

/**
 * @summary Create knowledge document and generate upload URL
 */
export const useCreateKnowledgeDocument = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKnowledgeDocument>>,
      TError,
      { organizationId: string; data: CreateKnowledgeDocumentBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createKnowledgeDocument>>,
  TError,
  { organizationId: string; data: CreateKnowledgeDocumentBody },
  TContext
> => {
  return useMutation(
    getCreateKnowledgeDocumentMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Get knowledge documents
 */
export const getKnowledgeDocuments = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetKnowledgeDocuments200Item[]>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/knowledge/documents`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetKnowledgeDocumentsQueryKey = (organizationId: string) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/knowledge/documents`,
  ] as const;
};

export const getGetKnowledgeDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getKnowledgeDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetKnowledgeDocumentsQueryKey(organizationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getKnowledgeDocuments>>
  > = ({ signal }) =>
    getKnowledgeDocuments(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getKnowledgeDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetKnowledgeDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKnowledgeDocuments>>
>;
export type GetKnowledgeDocumentsQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetKnowledgeDocuments<
  TData = Awaited<ReturnType<typeof getKnowledgeDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgeDocuments>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgeDocuments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKnowledgeDocuments<
  TData = Awaited<ReturnType<typeof getKnowledgeDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgeDocuments>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgeDocuments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKnowledgeDocuments<
  TData = Awaited<ReturnType<typeof getKnowledgeDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get knowledge documents
 */

export function useGetKnowledgeDocuments<
  TData = Awaited<ReturnType<typeof getKnowledgeDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeDocuments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetKnowledgeDocumentsQueryOptions(
    organizationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update knowledge document status
 */
export const updateKnowledgeDocument = (
  organizationId: string,
  documentId: string,
  updateKnowledgeDocumentBody: UpdateKnowledgeDocumentBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/knowledge/documents/${documentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateKnowledgeDocumentBody,
      signal,
    },
    options
  );
};

export const getUpdateKnowledgeDocumentMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateKnowledgeDocument>>,
    TError,
    {
      organizationId: string;
      documentId: string;
      data: UpdateKnowledgeDocumentBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateKnowledgeDocument>>,
  TError,
  {
    organizationId: string;
    documentId: string;
    data: UpdateKnowledgeDocumentBody;
  },
  TContext
> => {
  const mutationKey = ["updateKnowledgeDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateKnowledgeDocument>>,
    {
      organizationId: string;
      documentId: string;
      data: UpdateKnowledgeDocumentBody;
    }
  > = (props) => {
    const { organizationId, documentId, data } = props ?? {};

    return updateKnowledgeDocument(
      organizationId,
      documentId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateKnowledgeDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateKnowledgeDocument>>
>;
export type UpdateKnowledgeDocumentMutationBody = UpdateKnowledgeDocumentBody;
export type UpdateKnowledgeDocumentMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update knowledge document status
 */
export const useUpdateKnowledgeDocument = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateKnowledgeDocument>>,
      TError,
      {
        organizationId: string;
        documentId: string;
        data: UpdateKnowledgeDocumentBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateKnowledgeDocument>>,
  TError,
  {
    organizationId: string;
    documentId: string;
    data: UpdateKnowledgeDocumentBody;
  },
  TContext
> => {
  return useMutation(
    getUpdateKnowledgeDocumentMutationOptions(options),
    queryClient
  );
};
/**
 * Archives a knowledge document and removes it from the RAG knowledge base
 * @summary Archive knowledge document
 */
export const archiveKnowledgeDocument = (
  organizationId: string,
  documentId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/knowledge/documents/${documentId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getArchiveKnowledgeDocumentMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveKnowledgeDocument>>,
    TError,
    { organizationId: string; documentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveKnowledgeDocument>>,
  TError,
  { organizationId: string; documentId: string },
  TContext
> => {
  const mutationKey = ["archiveKnowledgeDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveKnowledgeDocument>>,
    { organizationId: string; documentId: string }
  > = (props) => {
    const { organizationId, documentId } = props ?? {};

    return archiveKnowledgeDocument(organizationId, documentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveKnowledgeDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveKnowledgeDocument>>
>;

export type ArchiveKnowledgeDocumentMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Archive knowledge document
 */
export const useArchiveKnowledgeDocument = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveKnowledgeDocument>>,
      TError,
      { organizationId: string; documentId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof archiveKnowledgeDocument>>,
  TError,
  { organizationId: string; documentId: string },
  TContext
> => {
  return useMutation(
    getArchiveKnowledgeDocumentMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Create upload record
 */
export const createUpload = (
  organizationId: string,
  projectId: string,
  createUploadBody: CreateUploadBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Upload>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/uploads`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createUploadBody,
      signal,
    },
    options
  );
};

export const getCreateUploadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpload>>,
    TError,
    { organizationId: string; projectId: string; data: CreateUploadBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUpload>>,
  TError,
  { organizationId: string; projectId: string; data: CreateUploadBody },
  TContext
> => {
  const mutationKey = ["createUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUpload>>,
    { organizationId: string; projectId: string; data: CreateUploadBody }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return createUpload(organizationId, projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpload>>
>;
export type CreateUploadMutationBody = CreateUploadBody;
export type CreateUploadMutationError = unknown;

/**
 * @summary Create upload record
 */
export const useCreateUpload = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUpload>>,
      TError,
      { organizationId: string; projectId: string; data: CreateUploadBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createUpload>>,
  TError,
  { organizationId: string; projectId: string; data: CreateUploadBody },
  TContext
> => {
  return useMutation(getCreateUploadMutationOptions(options), queryClient);
};
/**
 * @summary List documents
 */
export const listDocuments = (
  organizationId: string,
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ListDocuments200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListDocumentsQueryKey = (
  organizationId: string,
  projectId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents`,
  ] as const;
};

export const getListDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDocumentsQueryKey(organizationId, projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocuments>>> = ({
    signal,
  }) => listDocuments(organizationId, projectId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocuments>>
>;
export type ListDocumentsQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useListDocuments<
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocuments>>,
          TError,
          Awaited<ReturnType<typeof listDocuments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDocuments<
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocuments>>,
          TError,
          Awaited<ReturnType<typeof listDocuments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDocuments<
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List documents
 */

export function useListDocuments<
  TData = Awaited<ReturnType<typeof listDocuments>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListDocumentsQueryOptions(
    organizationId,
    projectId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get document details
 */
export const getDocumentDetails = (
  organizationId: string,
  projectId: string,
  documentId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Document>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetDocumentDetailsQueryKey = (
  organizationId: string,
  projectId: string,
  documentId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}`,
  ] as const;
};

export const getGetDocumentDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentDetails>>,
  TError = unknown,
>(
  organizationId: string,
  projectId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDocumentDetailsQueryKey(organizationId, projectId, documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentDetails>>
  > = ({ signal }) =>
    getDocumentDetails(
      organizationId,
      projectId,
      documentId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && documentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDocumentDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentDetails>>
>;
export type GetDocumentDetailsQueryError = unknown;

export function useGetDocumentDetails<
  TData = Awaited<ReturnType<typeof getDocumentDetails>>,
  TError = unknown,
>(
  organizationId: string,
  projectId: string,
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentDetails>>,
          TError,
          Awaited<ReturnType<typeof getDocumentDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocumentDetails<
  TData = Awaited<ReturnType<typeof getDocumentDetails>>,
  TError = unknown,
>(
  organizationId: string,
  projectId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentDetails>>,
          TError,
          Awaited<ReturnType<typeof getDocumentDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocumentDetails<
  TData = Awaited<ReturnType<typeof getDocumentDetails>>,
  TError = unknown,
>(
  organizationId: string,
  projectId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get document details
 */

export function useGetDocumentDetails<
  TData = Awaited<ReturnType<typeof getDocumentDetails>>,
  TError = unknown,
>(
  organizationId: string,
  projectId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDocumentDetailsQueryOptions(
    organizationId,
    projectId,
    documentId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete document
 */
export const deleteDocument = (
  organizationId: string,
  projectId: string,
  documentId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteDocumentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDocument>>,
    TError,
    { organizationId: string; projectId: string; documentId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDocument>>,
  TError,
  { organizationId: string; projectId: string; documentId: string },
  TContext
> => {
  const mutationKey = ["deleteDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDocument>>,
    { organizationId: string; projectId: string; documentId: string }
  > = (props) => {
    const { organizationId, projectId, documentId } = props ?? {};

    return deleteDocument(
      organizationId,
      projectId,
      documentId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDocument>>
>;

export type DeleteDocumentMutationError = unknown;

/**
 * @summary Delete document
 */
export const useDeleteDocument = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDocument>>,
      TError,
      { organizationId: string; projectId: string; documentId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDocument>>,
  TError,
  { organizationId: string; projectId: string; documentId: string },
  TContext
> => {
  return useMutation(getDeleteDocumentMutationOptions(options), queryClient);
};
/**
 * @summary Update document
 */
export const updateDocument = (
  organizationId: string,
  projectId: string,
  documentId: string,
  updateDocumentBody: UpdateDocumentBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Document>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateDocumentBody,
      signal,
    },
    options
  );
};

export const getUpdateDocumentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocument>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      documentId: string;
      data: UpdateDocumentBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDocument>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    documentId: string;
    data: UpdateDocumentBody;
  },
  TContext
> => {
  const mutationKey = ["updateDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDocument>>,
    {
      organizationId: string;
      projectId: string;
      documentId: string;
      data: UpdateDocumentBody;
    }
  > = (props) => {
    const { organizationId, projectId, documentId, data } = props ?? {};

    return updateDocument(
      organizationId,
      projectId,
      documentId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDocument>>
>;
export type UpdateDocumentMutationBody = UpdateDocumentBody;
export type UpdateDocumentMutationError = unknown;

/**
 * @summary Update document
 */
export const useUpdateDocument = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDocument>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        documentId: string;
        data: UpdateDocumentBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDocument>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    documentId: string;
    data: UpdateDocumentBody;
  },
  TContext
> => {
  return useMutation(getUpdateDocumentMutationOptions(options), queryClient);
};
/**
 * @summary Get download URL
 */
export const getDocumentDownloadUrl = (
  organizationId: string,
  projectId: string,
  documentId: string,
  params?: GetDocumentDownloadUrlParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetDocumentDownloadUrl200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/documents/${documentId}/download-url`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getGetDocumentDownloadUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      documentId: string;
      params?: GetDocumentDownloadUrlParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    documentId: string;
    params?: GetDocumentDownloadUrlParams;
  },
  TContext
> => {
  const mutationKey = ["getDocumentDownloadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
    {
      organizationId: string;
      projectId: string;
      documentId: string;
      params?: GetDocumentDownloadUrlParams;
    }
  > = (props) => {
    const { organizationId, projectId, documentId, params } = props ?? {};

    return getDocumentDownloadUrl(
      organizationId,
      projectId,
      documentId,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetDocumentDownloadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentDownloadUrl>>
>;

export type GetDocumentDownloadUrlMutationError = unknown;

/**
 * @summary Get download URL
 */
export const useGetDocumentDownloadUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        documentId: string;
        params?: GetDocumentDownloadUrlParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    documentId: string;
    params?: GetDocumentDownloadUrlParams;
  },
  TContext
> => {
  return useMutation(
    getGetDocumentDownloadUrlMutationOptions(options),
    queryClient
  );
};
